function CustomErrorForErrorBoundary(props: any) {
  console.error({ props: props?.error });
  return <h1>Unexpected error occurred! Please visit us later.</h1>;
}

export default CustomErrorForErrorBoundary;
